import Global from "../../Global"

const serverUrl =
  process.env.NODE_ENV === "development"
  	? `${ Global.SERVER_API_URL }/api`
  	: `${ window.location.origin }/api`

const getDownloadTitleImageUrl = (imageId, newsId) => {
	return `${ serverUrl
	}/news/downloadNewsFile?fileId=${
		imageId }&newsId=${
		newsId }&isTitle=true`
}

export default getDownloadTitleImageUrl